import type { User } from '@libs/contexts';
import { IconButton } from '@mui/material';
import { globalAreaButtonFont, nonOverflowText } from '../styles';
import { Arrow } from './Arrow';

interface UserButtonProps {
  user: User;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

function UserButton(props: UserButtonProps) {
  const { user, anchorEl, setAnchorEl } = props;

  return (
    <IconButton
      id="user-panel"
      disableTouchRipple
      onClick={(e) => setAnchorEl(e.currentTarget)}
      sx={{ ...globalAreaButtonFont, borderRadius: '0%', marginTop: '2px', width: '200px' }}
    >
      <div
        style={{
          ...nonOverflowText,
          maxWidth: '150px',
        }}
      >
        {user.name}
      </div>
      <Arrow open={!!anchorEl} />
    </IconButton>
  );
}

export { UserButton };
export type { UserButtonProps };
